var mallPage4i = function(){
  const accordions = new getAccordions4i();
  const init = () => {
    const wrapper = document.querySelector("#mainContent");
    accordions.init(wrapper);			
  };
  return{
    Init: init
  };
};
(async () => {
  const mallPage = new mallPage4i();
  mallPage.Init();
})();